const EXTENSION_STORAGE_KEY = "extensionStorage";
const BUY_AGAIN_TOKEN_SUFFIX = "buy-again-token";
const FALLBACK_TOKEN_KEY = "buy-again-token";

function readFromExtensionStorage(suffix: string): string | null {
  if (typeof window === "undefined") return null;
  const raw = window.localStorage.getItem(EXTENSION_STORAGE_KEY);
  if (!raw) return null;
  const data = JSON.parse(raw) as Record<string, string>;
  const key = Object.keys(data).find((k) => k.includes(suffix));
  if (!key) return null;
  const value = data[key];
  return typeof value === "string" && value.length > 0 ? value : null;
}

export function getTokenFromUrl(): string | null {
  if (typeof window === "undefined") return null;
  const params = new URLSearchParams(window.location.search);
  const token = params.get("so-token");
  return typeof token === "string" && token.length > 0 ? token : null;
}

export function getStoredToken(): string | null {
  if (typeof window === "undefined") return null;
  try {
    const fromExtension = readFromExtensionStorage(BUY_AGAIN_TOKEN_SUFFIX);
    if (fromExtension) {
      window.localStorage.setItem(FALLBACK_TOKEN_KEY, fromExtension);
      return fromExtension;
    }
    const fromFallback = window.localStorage.getItem(FALLBACK_TOKEN_KEY);
    return typeof fromFallback === "string" && fromFallback.length > 0
      ? fromFallback
      : null;
  } catch {
    return null;
  }
}
